<template>
  <div>
    <div class="text-white text-28 leading-36 font-bold my-4 ml-4 sm:ml-0">Onedio'da Popüler</div>
    <div class="flex flex-wrap gap-4 sm:w-[344px] pl-4 sm:pl-0">
      <OLink
        v-for="card in popularAstrologyCards"
        :key="card.id"
        :href="card.href"
        class="
          astrology-card
          relative
          w-[164px]
          h-[212px]
          flex flex-col
          py-3
          justify-between
          border border-[#424242]
          rounded-[20px]
          overflow-hidden
          hover:border-gray-500
        "
      >
        <div class="flex flex-col gap-1 px-3">
          <p class="text-white text-20 leading-24 font-bold items-center">{{ card.title }}</p>
          <p class="text-primary-300 text-sm font-normal leading-18 items-center">{{ card.description }}</p>
        </div>
        <OImage :src="card.image" :alt="card.title" class="absolute object-cover z-0" :class="card.imageClass" />
        <OButton
          v-if="card.text"
          pure
          class="z-1 u-center self-center px-8 py-2 text-md font-medium bg-[#6842EF] text-white leading-24 rounded-full"
          :href="card.href"
        >
          {{ card.text }}
        </OButton>
      </OLink>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OLink, OButton } from '~/modules/common/components/ui';
import OImage from '~/modules/common/components/ui/OImage/OImage.vue';
import { popularAstrologyCards } from '~/modules/astrology/utils/astrologyUtils';

export default defineComponent({
  components: {
    OLink,
    OImage,
    OButton,
  },
  setup() {
    return {
      popularAstrologyCards,
    };
  },
});
</script>

<style scoped lang="scss">
.astrology-card {
  background: linear-gradient(180deg, #181819 40%, rgba(46, 34, 112, 0.5) 100%);
  width: calc((100% - 32px) / 2);
  aspect-ratio: 164 / 212;
  @include sm() {
    width: 164px;
    height: 212px;
  }
}
</style>
